import {Injectable, Inject} from '@angular/core';
import {Response, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {TokenHttp} from '../../core/services/token-http';
import {KvItem} from '../../core/models/kv-item';
import {DocumentMaster} from '../models/document-master';

@Injectable()
export class DocumentService {

  constructor(private http: TokenHttp,
              @Inject('ApplicationConfig') private config: any) { }

  upload(file: File, id: number, filename: string): Observable<KvItem> {
    return this.http.uploadFile(this.config.apiEndpoint + '/api/document/upload?id=' + id, file, filename)
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error));
  }

  download(id: number): Observable<ArrayBuffer> {

    return this.http.get(this.config.apiEndpoint + '/api/document/download?id=' + id, { responseType: ResponseContentType.ArrayBuffer})
      .map((response: any) => [response['_body']])
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  upsertMetadata(metadata: DocumentMaster): Observable<number> {
    return this.http.post(this.config.apiEndpoint + '/api/document/upsertmetadata', metadata)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  retrieve(id: number): Observable<DocumentMaster> {
    return this.http.get(this.config.apiEndpoint + '/api/document/retrieve?id=' + id)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  retrieveForIds(ids: Array<number>): Observable<DocumentMaster[]> {
    return this.http.post(this.config.apiEndpoint + '/api/document/retrieveforids', ids)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  retrieveActive(): Observable<DocumentMaster[]> {
    return this.http.get(this.config.apiEndpoint + '/api/document/retrieveallactive')
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  retrieveDeleted(): Observable<DocumentMaster[]> {
    return this.http.get(this.config.apiEndpoint + '/api/document/retrievealldeleted')
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  remove(id: number): Observable<boolean> {
    return this.http.get(this.config.apiEndpoint + '/api/document/remove?id=' + id)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/services/document.ts